import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import {
  setUserRole,
  updateMicStatus,
  updateRoomStatus,
  awardTrophy,
} from "@saas/server-api/src/live-sdk";
import { EventBus } from "@saas/components/src/utils/event-bus";

export default {
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapState("live", ["liveService", "roomInfo", "imService"]),
  },
  methods: {
    ...mapMutations("live", ["setRoomInfo", "setShowTrophy"]),
    // 操作全体下台
    handleAllRemoteDownStage() {
      return new Promise((resolve, reject) => {
        try {
          updateRoomStatus({
            id: this.roomInfo.id,
            is_up_stage: 2,
          }).then((res) => {
            if (res.code === 1) {
              EventBus.$emit("downstage", { userId: "*" });
              this.imService.sendMGLiveRoomCustomMsg({
                cmdId: 2,
                data: {
                  type: "downstage",
                  data: {
                    userId: "*",
                    isDown: true,
                  },
                },
              });
              resolve();
            } else {
              this.$darkMessage.error(res.message);
              reject(res.message);
            }
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 操作远端用户上下台 status 1 上台 2 下台
    handleRemoteUpDown(userId, status) {
      return new Promise((resolve, reject) => {
        setUserRole({
          is_up_stage: status,
          user_id: userId,
          room_id: this.roomInfo.id,
        })
          .then((res) => {
            if (res.code === 1) {
              this.imService.sendMGLiveRoomCustomMsg({
                cmdId: 2,
                data: {
                  type: "downstage",
                  data: {
                    userId: userId,
                    isDown: status === 1 ? false : true,
                    isWhiteboard: this.roomInfo.up_stage_whiteboard, // 1  可操作
                    isSendAudio: this.roomInfo.up_stage_audio, // 1 可操作
                    isSendVideo: this.roomInfo.up_stage_video, // 1 可操作
                  },
                },
              });
              EventBus.$emit("downstage", {
                userId: userId,
                isDown: status === 1 ? false : true,
              });
              resolve(res);
            } else {
              this.$darkMessage.error(res.message);
              reject(res.message);
            }
          })
          .catch((err) => {
            reject(err.message);
          });
      });
    },
    // 操作远端用户白板状态 status 1 可操作 2 不可操作
    handleRemoteWhiteboard(userId, status) {
      return new Promise((resolve, reject) => {
        setUserRole({
          is_whiteboard: status,
          user_id: userId,
          room_id: this.roomInfo.id,
        })
          .then((res) => {
            if (res.code === 1) {
              this.imService.sendMGLiveRoomCustomMsg({
                cmdId: 2,
                data: {
                  type: "whiteboard",
                  data: {
                    userId: userId,
                    isWhiteboard: status === 1 ? true : false,
                  },
                },
              });
              resolve(res);
            } else {
              this.$darkMessage.error(res.message);
              reject(res.message);
            }
          })
          .catch((err) => {
            reject(err.message);
          });
      });
    },

    // 操作远端用户麦克风状态
    handleRemoteAudio(userId, status) {
      return new Promise((resolve, reject) => {
        setUserRole({
          is_send_audio: status,
          user_id: userId,
          room_id: this.roomInfo.id,
        })
          .then((res) => {
            if (res.code === 1) {
              this.imService.sendMGLiveRoomCustomMsg({
                cmdId: 2,
                data: {
                  type: "audioMute",
                  data: {
                    userId: userId,
                    isMute: status === 1 ? false : true,
                  },
                },
              });
              EventBus.$emit("audioMute", {
                userId: userId,
                isMute: status === 1 ? false : true,
              });
              resolve(res);
            } else {
              this.$darkMessage.error(res.message);
              reject(res.message);
            }
          })
          .catch((err) => {
            reject(err.message);
          });
      });
    },
    // 操作全体麦克风状态
    handleAllRemoteAudio(status) {
      return new Promise((resolve, reject) => {
        updateRoomStatus({
          id: this.roomInfo.id,
          is_send_audio: status,
        })
          .then((res) => {
            if (res.code === 1) {
              this.imService.sendMGLiveRoomCustomMsg({
                cmdId: 2,
                data: {
                  type: "audioMute",
                  data: {
                    userId: "*",
                    isMute: status === 1 ? false : true,
                  },
                },
              });
              this.setRoomInfo({
                is_send_audio: status,
              });
              EventBus.$emit("audioMute", {
                userId: "*",
                isMute: status === 1 ? false : true,
              });
              resolve(res);
            } else {
              this.$darkMessage.error(res.message);
              reject(res.message);
            }
          })
          .catch((err) => {
            reject(err.message);
          });
      });
    },
    // 操作远端用户摄像头状态
    handleRemoteVideo(userId, status) {
      return new Promise((resolve, reject) => {
        setUserRole({
          is_send_video: status,
          user_id: userId,
          room_id: this.roomInfo.id,
        })
          .then((res) => {
            if (res.code === 1) {
              this.imService.sendMGLiveRoomCustomMsg({
                cmdId: 2,
                data: {
                  type: "videoMute",
                  data: {
                    userId: userId,
                    isMute: status === 1 ? false : true,
                  },
                },
              });
              EventBus.$emit("videoMute", {
                userId: userId,
                isMute: status === 1 ? false : true,
              });
              resolve(res);
            } else {
              this.$darkMessage.error(res.message);
              reject(res.message);
            }
          })
          .catch((err) => {
            reject(err.message);
          });
      });
    },
    // 操作全体摄像头状态
    handleAllRemoteVideo(status) {
      return new Promise((resolve, reject) => {
        updateRoomStatus({
          id: this.roomInfo.id,
          is_send_video: status,
        })
          .then((res) => {
            if (res.code === 1) {
              this.imService.sendMGLiveRoomCustomMsg({
                cmdId: 2,
                data: {
                  type: "videoMute",
                  data: {
                    userId: "*",
                    isMute: status === 1 ? false : true,
                  },
                },
              });
              this.setRoomInfo({
                is_send_video: status,
              });
              EventBus.$emit("videoMute", {
                userId: "*",
                isMute: status === 1 ? false : true,
              });
              resolve(res);
            } else {
              this.$darkMessage.error(res.message);
              reject(res.message);
            }
          })
          .catch((err) => {
            reject(err.message);
          });
      });
    },
    // 操作全体消息状态
    handleAllRemoteMessage(status) {
      return new Promise((resolve, reject) => {
        updateRoomStatus({
          id: this.roomInfo.id,
          is_send_msg: status,
        })
          .then((res) => {
            if (res.code === 1) {
              this.imService.sendMGLiveRoomCustomMsg({
                cmdId: 2,
                data: {
                  type: "messageMute",
                  data: {
                    userId: "*",
                    isMute: status === 1 ? false : true,
                    time: Math.floor(Date.now() / 1000),
                  },
                },
              });
              EventBus.$emit("messageMute", {
                userId: "*",
                isMute: status === 1 ? false : true,
              });
              this.setRoomInfo({
                is_send_msg: status,
              });
              resolve(res);
            } else {
              this.$darkMessage.error(res.message);
              reject(res.message);
            }
          })
          .catch((err) => {
            reject(err.message);
          });
      });
    },
    // 操作某人发消息状态
    handleRemoteMessage(userId, status) {
      return new Promise((resolve, reject) => {
        setUserRole({
          is_send_msg: status,
          user_id: userId,
          room_id: this.roomInfo.id,
        })
          .then((res) => {
            if (res.code === 1) {
              this.imService.sendMGLiveRoomCustomMsg({
                cmdId: 2,
                data: {
                  type: "messageMute",
                  data: {
                    userId: userId,
                    isMute: status === 1 ? false : true,
                    time: Math.floor(Date.now() / 1000),
                  },
                },
              });
              EventBus.$emit("messageMute", {
                userId: userId,
                isMute: status === 1 ? false : true,
              });
              resolve(res);
            } else {
              this.$darkMessage.error(res.message);
              reject(res.message);
            }
          })
          .catch((err) => {
            reject(err.message);
          });
      });
    },
    // 发放奖杯
    handleAwardTrophy(userId) {
      return new Promise((resolve, reject) => {
        awardTrophy({
          user_id: userId, // 用户id， * 表示全体
          room_id: this.roomInfo.id,
        })
          .then((res) => {
            if (res.code === 1) {
              this.imService.sendMGLiveRoomCustomMsg({
                cmdId: 2,
                data: {
                  type: "trophy",
                  data: {
                    userId: userId,
                  },
                },
              });
              EventBus.$emit("trophy", {
                userId: userId,
              });
              this.setShowTrophy({
                visible: true,
                info: {
                  userId: userId,
                },
              });
              resolve(res);
            } else {
              this.$darkMessage.error(res.message);
              reject(res.message);
            }
          })
          .catch((err) => {
            reject(err.message);
          });
      });
    },
  },
};
